import Quill from "quill";

// Extend Quill's built-in Image format
const Image = Quill.import("formats/image");

class CustomImageBlot extends Image {
  static create(value) {
    let node = super.create(value);
    if (typeof value === "object") {
      node.setAttribute("src", value.src);
      node.setAttribute("style", `width: ${value.width}; height: ${value.height};`);
    }
    return node;
  }

  static formats(domNode) {
    const width = domNode.style.width || "auto";
    const height = domNode.style.height || "auto";
    return {
      src: domNode.getAttribute("src"),
      width,
      height,
    };
  }

  format(name, value) {
    if (name === "width" || name === "height") {
      this.domNode.style[name] = value;
    } else {
      super.format(name, value);
    }
  }
}

// Register the custom Image Blot
Quill.register("formats/image", CustomImageBlot);